import { render, staticRenderFns } from "./DayForm.vue?vue&type=template&id=453223ba&scoped=true&"
import script from "./DayForm.vue?vue&type=script&lang=js&"
export * from "./DayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453223ba",
  null
  
)

export default component.exports